import React from 'react';
import { Chip } from 'primereact/chip';
import styled from 'styled-components';
import FontIcon from 'components/icons/FontIcon';

interface Props {
  text: string;
  onClick(): void;
}

const FilterChip: React.FC<Props> = ({ text, onClick }) => {
  return (
    <StyledChip
      label={text}
      removable
      onClick={onClick}
      removeIcon={
        <FontIcon
          /* Need to provide some 'key' to avoid warning in console :shrug: */
          key={0}
          icon="chip-x"
          style={{
            transform: 'translateY(2px)',
            marginLeft: 4,
            fontSize: 16,
          }}
        />
      }
    />
  );
};

export default FilterChip;

const StyledChip = styled(Chip)`
  ${(props) => props.theme.typography.bodyInput}
  background-color: ${(props) => props.theme.colors.secondaryLightGreen30};
  color: ${(props) => props.theme.colors.primaryGreen};
  border-radius: 4px;
  padding: 4px 6px;
  height: 25px;
  display: flex;
  cursor: pointer;
  & span {
    flex-wrap: nowrap;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
